import React from 'react'
import PdaTitle from '../../component/common/PdaTitle'
import LogoDark from '../../component/common/LogoDark'
import { PdaMenuItem } from '../../types/common'
import MenuLink from '../../component/common/MenuLink'
import { tokens } from '../../locales/tokens'
import { useTranslation } from 'react-i18next'

const InboundMenu = () => {
    const { t } = useTranslation()
    const menus: PdaMenuItem[] = [
        {
            name: t(tokens.inbound.new_incoming),
            uri: '/incoming',
        },
        {
            name: t(tokens.inbound.midmile_incoming),
            uri: '/midmile-incoming',
        },
        // 23.11.30. 협의 후 삭제
        /*{
            name: '회수 입고',
            uri: '/takeback-inbound',
        },*/
    ]

    return (
        <>
            <PdaTitle title={t(tokens.inbound.incoming_management)} historyBack />
            <LogoDark />
            <MenuLink items={menus} color="bg-color-blue border-color-blue" />
            {/*<div className="bg-color-blue border-color-blue"></div>*/}
        </>
    )
}

export default InboundMenu
